import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type UserData = {
  currentAddress: string;
  firstName: string;
  organizationId: string;
  permanentAddress: string;
  userId: string;
  userName: string;
  role: string;
  organizationName: string;
  userType: string;
  state: string;
  stateId: string;
  division: string;
  divsionId: string;
  isNew: boolean;
  isGCAEntity: boolean;
  gcaType: string; // GCA profile type: 'TYPE_2' = PSU
  organizationType: {
    id: string;
    type: string;
  };
};

type User = {
  isLoggedIn: boolean;
  name: string;
  devType: string;
  data: UserData;
};

const initialState: User = {
  isLoggedIn: false,
  name: "Green Credit",
  devType: "INDIVIDUAL",
  data: {
    currentAddress: "",
    firstName: "",
    organizationId: "",
    permanentAddress: "",
    organizationName: "",
    userId: "",
    userName: "",
    userType: "",
    role: "",
    state: "",
    stateId: "",
    division: "",
    divsionId: "",
    isNew: false,
    isGCAEntity: false,
    gcaType: "",
    organizationType: {
      id: "",
      type: "",
    },
  },
};
const userDetails = createSlice({
  name: "user",
  initialState,
  reducers: {
    login: (state, action: PayloadAction<any>) => {
      state.isLoggedIn = true;
      state.name = "Green Credit";
      state.devType = "INDIVIDUAL";
      // Map API response to UserData structure
      state.data = {
        currentAddress: action.payload.currentAddress?.addressLine1 || "",
        firstName: action.payload.firstName || "",
        organizationId: action.payload.organizationId || "",
        permanentAddress: action.payload.permanentAddress?.addressLine1 || "",
        userId: action.payload.userId || "",
        userName: action.payload.userName || "",
        role: action.payload.role || "",
        organizationName: action.payload.organizationName || "",
        userType: action.payload.userType,
        state: action.payload.currentAddress?.state || "",
        stateId: action.payload.currentAddress?.stateId || "",
        division: action.payload.division || "",
        divsionId: action.payload.divsionId || "",
        isNew: action.payload.isNew || false,
        isGCAEntity: action.payload.isGCAEntity || false,
        gcaType: action.payload.gca_type || "",
        organizationType: action.payload.organizationType || {
          id: "",
          type: "",
        },
      };
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.name = "";
      state.data = initialState.data;
      localStorage.clear();
    },
    updateGCAEntityStatus: (state, action: PayloadAction<boolean>) => {
      state.data.isGCAEntity = action.payload;
    },
  },
});

export const { logout, login, updateGCAEntityStatus } = userDetails.actions;
export default userDetails.reducer;
